import { Typography } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';

import { ProgressDots } from '@/components/DataDisplay/Indicator/ProgressDots';
import { Logo } from '@/components/Icon/Logo';
import { Screen } from '@/components/Layout/Screen';
import { PhoneForm } from '@/components/PageForm/PhoneForm';

import { useAppTheme } from '@/context/AppThemeContext';

import { useTranslate } from '@/hooks/useTranslate';

import { PROGRESS_STEPS } from '@/utils/progressSteps';

export default function PhoneScreen() {
  const { t } = useTranslate();
  const theme = useTheme();
  const { theme: appThemeConfig } = useAppTheme();

  return (
    <Screen
      header={{
        centerSlot: <ProgressDots {...PROGRESS_STEPS.phoneStep} />,
        bgColor: (theme: Theme) => theme.palette.background.paper,
      }}
      center
      bgColor={(theme: Theme) => theme.palette.background.paper}
    >
      <Logo src={appThemeConfig.logo} />
      <Typography variant="h3" textAlign="center" mb={1}>
        {t('phone.title')}
      </Typography>
      <Typography
        variant="body2"
        color={theme.palette.grey[800]}
        textAlign="center"
        mb={2}
      >
        {t('phone.description')}
      </Typography>
      <PhoneForm />
    </Screen>
  );
}
